export default __webpack_public_path__ + "media/images/paylogos/gray/mastercard_electronic-0082b9af1a5ff0a041443f86e9d3e8e4.png";